<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newOrder()"
                aria-label="Add order">
            {{'Add order'|translate}}
        </button>
    </div>

    <div class="nav material2">
        <div class="nav-item">
<!--            <a class="nav-link" matRipple [routerLink]="'/orders'" [routerLinkActive]="[]">-->
<!--                <mat-icon class="nav-link-icon">local_shipping</mat-icon>-->
<!--                <span>{{'Orders history'|translate}}</span>-->
<!--            </a>-->
        </div>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
